var React = require('react');

function IconEducation (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","fillRule":"nonzero","d":"M9.273 16.483v3.334L15 23l5.727-3.183v-3.334L15 19.667l-5.727-3.184zM15 8l-9 5 9 5 7.364-4.092v5.759H24V13l-9-5z"}));
}

IconEducation.displayName = "IconEducation";

IconEducation.defaultProps = {"width":"32","height":"32"};

module.exports = IconEducation;

IconEducation.default = IconEducation;
